/**
 * CLICKAR.BIZ INTERNATIONAL REST API
 * APIs Clickar.biz international.
 *
 * OpenAPI spec version: API V1
 * Contact: blureply@reply.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { EventEmitter, Injectable, Optional } from "@angular/core";
import { environment } from "@app/../environments/environment";
import { HeaderKey } from "@shared/clickar-constants";
import { AuctionDateDTO } from "@shared/model/auction.model";
import { TemplateDTO, TemplateInfoDTO, TemplateLogoDTO } from "@shared/model/template.model";
import { Configuration } from "@shared/services/utils/configuration";
import { CustomHttpUrlEncodingCodec } from "@shared/services/utils/encoder";
import { Observable } from "rxjs";

@Injectable()
export class TemplateService {
	protected basePath = "https://localhost:8088";
	defaultHeaders = new HttpHeaders();
	configuration = new Configuration();
	partnersEmitter = new EventEmitter<boolean>();
	readonly encoderParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

	constructor(
		protected httpClient: HttpClient,
		@Optional() configuration: Configuration
	) {
		this.basePath = environment.baseApiUrl;

		if (configuration) {
			this.configuration = configuration;
			this.basePath = environment.baseApiUrl || configuration.basePath || this.basePath;
		}
	}

	/**
	 * @param consumes string[] mime-types
	 * @return true: consumes contains 'multipart/form-data', false: otherwise
	 */
	/* private canConsumeForm(consumes: string[]): boolean {
		const form = 'multipart/form-data';
		for (const consume of consumes) {
			if (form === consume) {
				return true;
			}
		}
		return false;
	} */

	/**
	 * createTemplate
	 *
	 * @param smallLogo
	 * @param largeLogo
	 * @param regulation
	 * @param templateDTO templateDTO
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	createTemplateUsingPOST(templateDTO: TemplateDTO, observe?: "body", reportProgress?: boolean): Observable<any>;
	createTemplateUsingPOST(templateDTO: TemplateDTO, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<any>>;
	createTemplateUsingPOST(templateDTO: TemplateDTO, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<any>>;
	createTemplateUsingPOST(templateDTO: TemplateDTO, observe: any = "body", reportProgress = false): Observable<any> {
		if (templateDTO === null || templateDTO === undefined) {
			throw new Error("Required parameter templateDTO was null or undefined when calling createTemplateUsingPOST.");
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(["application/json"]);
		if (httpContentTypeSelected != undefined) {
			headers = headers.set("Content-Type", httpContentTypeSelected);
		}

		return this.httpClient.post<any>(`${this.basePath}/api/v1/secure/template`,
			templateDTO,
			{
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * getTemplateAuctionDate
	 *
	 * @param idTemplate idTemplate
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getTemplateAuctionDateUsingGET(idTemplate: number, observe?: "body", reportProgress?: boolean): Observable<AuctionDateDTO[]>;
	getTemplateAuctionDateUsingGET(idTemplate: number, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<AuctionDateDTO[]>>;
	getTemplateAuctionDateUsingGET(idTemplate: number, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<AuctionDateDTO[]>>;
	getTemplateAuctionDateUsingGET(idTemplate: number, observe: any = "body", reportProgress = false): Observable<any> {

		if (idTemplate === null || idTemplate === undefined) {
			throw new Error("Required parameter idTemplate was null or undefined when calling getTemplateAuctionDateUsingGET.");
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		return this.httpClient.get<AuctionDateDTO[]>(`${this.basePath}/api/v1/secure/template/${encodeURIComponent(String(idTemplate))}`,
			{
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * getLogoByProvenance
	 *
	 * @param provenances provenances
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getLogoByProvenanceUsingGET(provenances: string[], observe?: "body", reportProgress?: boolean): Observable<{ [key: string]: TemplateLogoDTO; }>;
	getLogoByProvenanceUsingGET(provenances: string[], observe?: "response", reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: TemplateLogoDTO; }>>;
	getLogoByProvenanceUsingGET(provenances: string[], observe?: "events", reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: TemplateLogoDTO; }>>;
	getLogoByProvenanceUsingGET(provenances: string[], observe: any = "body", reportProgress = false): Observable<any> {

		if (provenances === null || provenances === undefined) {
			throw new Error("Required parameter provenances was null or undefined when calling getLogoByProvenanceUsingGET.");
		}

		let queryParameters = this.encoderParameters;

		if (provenances) {
			for (const element of provenances) {
				queryParameters = queryParameters.append("provenances", <any>element);
			}
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		return this.httpClient.get<{ [key: string]: TemplateLogoDTO; }>(`${this.basePath}/api/v1/secure/logoByProvenance`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * uploadFile
	 *
	 * @param file file
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	uploadFileUsingPOST(file: Blob, observe?: "body", reportProgress?: boolean): Observable<any>;
	uploadFileUsingPOST(file: Blob, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<any>>;
	uploadFileUsingPOST(file: Blob, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<any>>;
	uploadFileUsingPOST(file: Blob, observe: any = "body", reportProgress = false): Observable<any> {

		if (file === null || file === undefined) {
			throw new Error("Required parameter file was null or undefined when calling uploadRecDocUsingPOST.");
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		headers = headers.set(HeaderKey.NO_SUCCESS_POPUP, "true");

		// to determine the Content-Type header
		// const consumes = ['multipart/form-data'];

		const formData = new FormData();

		formData.append("file", file);

		return this.httpClient.post<any>(`${this.basePath}/api/v1/secure/file`,
			formData,
			{ headers }
		);
	}

	/**
	 * getTemplate
	 *
	 * @param idDealer
	 * @param idMarket
	 * @param ids ids
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getTemplateUsingGET(idDealer?: number, idMarket?: string, ids?: number[], observe?: "body", reportProgress?: boolean): Observable<TemplateDTO[]>;
	getTemplateUsingGET(idDealer?: number, idMarket?: string, ids?: number[], observe?: "response", reportProgress?: boolean): Observable<HttpResponse<TemplateDTO[]>>;
	getTemplateUsingGET(idDealer?: number, idMarket?: string, ids?: number[], observe?: "events", reportProgress?: boolean): Observable<HttpEvent<TemplateDTO[]>>;
	getTemplateUsingGET(idDealer?: number, idMarket?: string, ids?: number[], observe: any = "body", reportProgress = false): Observable<any> {
		let queryParameters = this.encoderParameters;
		if (idDealer !== undefined && idDealer !== null) {
			queryParameters = queryParameters.set("idDealer", <any>idDealer);
		}
		if (idMarket !== undefined && idMarket !== null) {
			queryParameters = queryParameters.set("idMarket", <any>idMarket);
		}
		if (ids) {
			for (const element of ids) {
				queryParameters = queryParameters.append("ids", <any>element);
			}
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		return this.httpClient.get<TemplateDTO[]>(`${this.basePath}/api/v1/secure/template`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * getTemplate
	 *
	 * @param ids ids
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getEnabledTemplateUsingGET(ids?: number[], observe?: "body", reportProgress?: boolean): Observable<TemplateDTO[]>;
	getEnabledTemplateUsingGET(ids?: number[], observe?: "response", reportProgress?: boolean): Observable<HttpResponse<TemplateDTO[]>>;
	getEnabledTemplateUsingGET(ids?: number[], observe?: "events", reportProgress?: boolean): Observable<HttpEvent<TemplateDTO[]>>;
	getEnabledTemplateUsingGET(ids?: number[], observe: any = "body", reportProgress = false): Observable<any> {
		let queryParameters = this.encoderParameters;
		if (ids) {
			for (const element of ids) {
				queryParameters = queryParameters.append("ids", <any>element);
			}
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		return this.httpClient.get<TemplateDTO[]>(`${this.basePath}/api/v1/secure/enabled-template`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * getTemplateInfo
	 *
	 * @param market market
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getTemplateInfoUsingGET(market?: string, observe?: "body", reportProgress?: boolean): Observable<TemplateInfoDTO[]>;
	getTemplateInfoUsingGET(market?: string, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<TemplateInfoDTO[]>>;
	getTemplateInfoUsingGET(market?: string, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<TemplateInfoDTO[]>>;
	getTemplateInfoUsingGET(market?: string, observe: any = "body", reportProgress = false): Observable<any> {
		let queryParameters = this.encoderParameters;
		if (market !== undefined && market !== null) {
			queryParameters = queryParameters.set("market", <any>market);
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		return this.httpClient.get<TemplateInfoDTO[]>(`${this.basePath}/api/v1/secure/template-info`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * editTemplate
	 *
	 * @param templateDTO templateDTO
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	editTemplateUsingPUT(templateDTO: TemplateDTO, observe?: "body", reportProgress?: boolean): Observable<any>;
	editTemplateUsingPUT(templateDTO: TemplateDTO, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<any>>;
	editTemplateUsingPUT(templateDTO: TemplateDTO, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<any>>;
	editTemplateUsingPUT(templateDTO: TemplateDTO, observe: any = "body", reportProgress = false): Observable<any> {
		if (templateDTO === null || templateDTO === undefined) {
			throw new Error("Required parameter templateDTO was null or undefined when calling editTemplateUsingPUT.");
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(["application/json"]);
		if (httpContentTypeSelected != undefined) {
			headers = headers.set("Content-Type", httpContentTypeSelected);
		}

		return this.httpClient.put<any>(`${this.basePath}/api/v1/secure/template`,
			templateDTO,
			{
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * deleteTemplate
	 *
	 * @param id id
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	deleteTemplateUsingDELETE(id: number, observe?: "body", reportProgress?: boolean): Observable<any>;
	deleteTemplateUsingDELETE(id: number, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<any>>;
	deleteTemplateUsingDELETE(id: number, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<any>>;
	deleteTemplateUsingDELETE(id: number, observe: any = "body", reportProgress = false): Observable<any> {

		if (id === null || id === undefined) {
			throw new Error("Required parameter id was null or undefined when calling deleteTemplateUsingDELETE.");
		}

		let queryParameters = this.encoderParameters;
		if (id !== undefined && id !== null) {
			queryParameters = queryParameters.set("id", <any>id);
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		return this.httpClient.delete<any>(`${this.basePath}/api/v1/secure/template`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * getPartners
	 *
	 * @param market market
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getPartnersOpenUsingGET(market?: string, observe?: "body", reportProgress?: boolean): Observable<any[]>;
	getPartnersOpenUsingGET(market?: string, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<any[]>>;
	getPartnersOpenUsingGET(market?: string, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<any[]>>;
	getPartnersOpenUsingGET(market?: string, observe: any = "body", reportProgress = false): Observable<any> {
		let queryParameters = this.encoderParameters;
		if (market !== undefined && market !== null) {
			queryParameters = queryParameters.set("market", <any>market);
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected)
				.set(HeaderKey.NO_POPUP, "true");
		}

		return this.httpClient.get<any[]>(`${this.basePath}/api/v1/open/partners`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * getMultiAuctioneerTemplate
	 *
	 * @param provenance
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getMultiAuctioneerTemplateUsingGET(provenance?: string, observe?: "body", reportProgress?: boolean): Observable<TemplateInfoDTO[]>;
	getMultiAuctioneerTemplateUsingGET(provenance?: string, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<TemplateInfoDTO[]>>;
	getMultiAuctioneerTemplateUsingGET(provenance?: string, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<TemplateInfoDTO[]>>;
	getMultiAuctioneerTemplateUsingGET(provenance?: string, observe: any = "body", reportProgress = false): Observable<any> {
		let headers = this.defaultHeaders,
			queryParameters = this.encoderParameters;
		if (provenance !== undefined && provenance !== null) {
			queryParameters = queryParameters.set("provenance", <any>provenance);
		}

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		return this.httpClient.get<TemplateInfoDTO[]>(`${this.basePath}/api/v1/secure/multi-auctioneer-template`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * getPartners
	 *
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getPartnersUsingGET(observe?: "body", reportProgress?: boolean): Observable<any>;
	getPartnersUsingGET(observe?: "response", reportProgress?: boolean): Observable<HttpResponse<any>>;
	getPartnersUsingGET(observe?: "events", reportProgress?: boolean): Observable<HttpEvent<any>>;
	getPartnersUsingGET(observe: any = "body", reportProgress = false): Observable<any> {

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		return this.httpClient.get<any>(`${this.basePath}/api/v1/secure/partners`,
			{
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * getEnabledMultiAuctioneerTemplate
	 *
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getEnabledMultiAuctioneerTemplateUsingGET(idDealer: number, observe?: "body", reportProgress?: boolean): Observable<any>;
	getEnabledMultiAuctioneerTemplateUsingGET(idDealer: number, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<any>>;
	getEnabledMultiAuctioneerTemplateUsingGET(idDealer: number, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<any>>;
	getEnabledMultiAuctioneerTemplateUsingGET(idDealer: number, observe: any = "body", reportProgress = false): Observable<any> {
		let headers = this.defaultHeaders;

		if (idDealer === null || idDealer === undefined) {
			throw new Error("Required parameter id was null or undefined when calling deleteTemplateUsingDELETE.");
		}

		let queryParameters = this.encoderParameters;
		if (idDealer !== undefined && idDealer !== null) {
			queryParameters = queryParameters.set("idDealer", <any>idDealer);
		}

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		return this.httpClient.get<any>(`${this.basePath}/api/v1/secure/multi-auctioneer-templates`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}
}